const routers = [

    {
        path: '/device/Information',
        name: 'DeviceInformation',
        component: resolve => require(['../views/device/Information'], resolve)
    },
    {
      path: '/device/enterpriseDevice',
      name: 'EnterpriseDevice',
      component: resolve => require(['../views/device/EnterpriseDevice'], resolve)
    },
    {
      path: '/device/Information/DeviceDescBasic',
      name: 'DeviceDescBasic',
      component: resolve => require(['../views/device/DeviceDescBasic'], resolve)
    },
    {
      path: '/device/Group',
      name: 'Group',
      component: resolve => require(['../views/device/Group'], resolve)
    },
    {
      path: '/device/Information/remoteControl',
      name: 'remoteControl',
      component: resolve => require(['../views/device/remoteControl'], resolve)
    },
    {
      path: '/device/deviceLifeCycle',
      name: 'deviceLifeCycle',
      component: resolve => require(['../views/device/deviceLifeCycle'], resolve)
    },
    {
      path: '/device/deviceDiagnosis',
      name: 'deviceDiagnosis',
      component: resolve => require(['../views/device/deviceDiagnosis'], resolve)
    },
    {
      path: '/device/deviceRegister',
      name: 'deviceRegister',
      component: resolve => require(['../views/device/deviceRegister'], resolve)
    }

]
export default routers



// WEBPACK FOOTER //
// ./src/routers/device.js